module.exports = __webpack_public_path__ + "files/1e475df2a5bc880172dd30ee0d7381d0.png";